/*
 * ADDRESS MANAGER
 */

$.ajaxSetup({ cache: false });


/**
 * modifica indirizzo
 */
$(document).on("click", "button.edit-address-button", function () {

    var li = $(this).closest('li.address-item');

    $.get( url__edit_address, {
        "id": li.attr("data-id"),
        "edit_mode": true,
        "t": li.attr("data-type")
    } , function( html ) {

        li.find(".address-item-wrapper").html(html);

        refreshSelect();
    });
});

/**
 * aggiungi indirizzo
 */
$(document).on("click", "button.add-address-button", function () {

    if(!$('.no-shipping-addresses').hasClass('d-none')) {
        $('.no-shipping-addresses').addClass('d-none');
    }

    $.get( url__edit_address, {
        "edit_mode": true
    } , function( html ) {

        $("ul#addresses-list").prepend("<li data-id=\"\" class=\"address-item\" data-type=\"\"><div class=\"container\"><div class=\"col-md-12 address-item-wrapper\">"+html+"</div></div></li>");

        refreshSelect();
    });
});

/**
 * salva indirizzo
 */
$(document).on("click", "button.save-address-button", function () {

    var li = $(this).closest('li.address-item');

    var url = url__save_address;
    url = url.replace('##ID##', li.attr("data-id"));
    url = url.replace('##TYPE##', 'SHIPPING');
    url = url.replace('##RETURN_HTML##', true);
    url = url.replace('##T##', li.attr("data-type"));

    $.post( url, li.find("form").serialize(), function( data ) {

        data = JSON.parse(data);

        if(data.result.status == 0) {
            location.reload();
        }
        li.attr("data-id", data.result.id);
        li.attr("data-type", data.result.t);
        li.find(".address-item-wrapper").html(data.html);

        refreshSelect();
    });
});

/**
 * elimina indirizzo
 */
$(document).on("click", "button.remove-address-button", function () {

    var li = $(this).closest('li.address-item');

    if($(this).closest('li.address-item').attr("data-id")) {
        $.get(url__profile_shipping_address_remove, {
            "id": li.attr("data-id"),
            "t": li.attr("data-type")
        }, function (result) {
            if(result) {
                //[SEMI-SYNC]
                //li.remove();
                //checkToShowNoAddressMessage();

                li.html("<div class=\"container\">"+result+"</div>");
            }
        });
    } else {
        li.remove();
        checkToShowNoAddressMessage();
    }
});

/**
 * Esegue il refresh del plugin sui campi select
 */
function refreshSelect() {
    $('#shipping_address_province').selectpicker('refresh');
    $('#shipping_address_nation').selectpicker('refresh');
}

function checkToShowNoAddressMessage() {
    if($("#addresses-list").find("li").length == 1) {
        $(".no-shipping-addresses").removeClass("d-none");
    }
}